import { Dialog, AppBar, Toolbar, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";


function PdfViewerDialog({ open, url, title = "Preview PDF", onClose }) {
    const toolbarPluginInstance = toolbarPlugin();
    const { renderDefaultToolbar, Toolbar: RpvToolbar } = toolbarPluginInstance;

    const transform = (slot) => ({
        ...slot,
        Open: () => <></>,
        OpenMenuItem: () => <></>,
        Download: () => <></>,
        DownloadMenuItem: () => <></>,
        Print: () => <></>,
        PrintMenuItem: () => <></>,
        SwitchTheme: () => <></>,
        SwitchThemeMenuItem: () => <></>,
    });

    return (
        <Dialog open={open} onClose={onClose} fullWidth
            maxWidth="md"
            TransitionProps={{ unmountOnExit: true }}
            PaperProps={{ sx: { borderRadius: 2 } }}
        >
            <AppBar
                className="appBar"
                position="relative"
                sx={{ bgcolor: "background.paper", color: "text.primary", }}
            >
                <Toolbar className="dialog-toolbar" sx={{ display: "flex", justifyContent: "space-between", }}>
                    <Box sx={{ fontWeight: 600 }}>{title}</Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <IconButton
                            edge="end"
                            color="inherit"
                            aria-label="close"
                            onClick={onClose}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>

            {url && (
                <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                        <Box sx={{ bgcolor: "#eee", borderBottom: "1px solid rgba(0,0,0,0.1)" }}>
                            <RpvToolbar>{renderDefaultToolbar(transform)}</RpvToolbar>
                        </Box>
                        <Box sx={{ flex: 1, minHeight: 0 }}>
                            <Viewer fileUrl={url} plugins={[toolbarPluginInstance]} />
                        </Box>
                    </Worker>
                </Box>
            )}
        </Dialog>
    );
}

export default PdfViewerDialog